<template>
<div class="chapter">
<div class="inner_page">
<div class="fs" id="page006">
<div class="jstfy" id="page006_0">6</div>
<div class="jstfy" id="page006_1">FRENCH CUISINE</div>
<div class="jstfy" id="page006_2">C<span class="small1">uisine</span> F<span class="small1">rançaise</span></div>
<div class="jstfy" id="page006_3">Since the fifteenth century, the cuisine</div>
<div class="jstfy" id="page006_4">cuisine’ spread around the country</div>
<div class="jstfy" id="page006_5">of France has been the most influential</div>
<div class="jstfy" id="page006_6">and abroad, becoming renowned the</div>
<div class="jstfy" id="page006_7">in Europe. It was at that time that the</div>
<div class="jstfy" id="page006_8">world over. Great importance was at-</div>
<div class="jstfy" id="page006_9">first cookery books were printed in the</div>
<div class="jstfy" id="page006_10">tached to culinary pleasure, particular-</div>
<div class="jstfy" id="page006_11">French language.</div>
<div class="jstfy" id="page006_12">ly among the upper classes.</div>
<div class="jstfy" id="page006_13">In the seventeenth and eighteenth</div>
<div class="jstfy" id="page006_14">Haute cuisine originated in the</div>
<div class="jstfy" id="page006_15">centuries, the French court was con-</div>
<div class="jstfy" id="page006_16">nineteenth century and developed</div>
<div class="jstfy" id="page006_17">sidered to be the most culturally ad-</div>
<div class="jstfy" id="page006_18">into the French national cuisine. It is</div>
<div class="jstfy" id="page006_19">vanced, and as a result, the French style</div>
<div class="jstfy" id="page006_20">characterised by its very high quality</div>
<div class="jstfy" id="page006_21">of cooking was adopted by the kitch-</div>
<div class="jstfy" id="page006_22">and versatility. However, many dif-</div>
<div class="jstfy" id="page006_23">ens of many noble houses throughout</div>
<div class="jstfy" id="page006_24">ferent styles of regional cooking can</div>
<div class="jstfy" id="page006_25">Europe. It was the origin of the tra-</div>
<div class="jstfy" id="page006_26">also be found throughout the country,</div>
<div class="jstfy" id="page006_27">ditional sequence of soup main course</div>
<div class="jstfy" id="page006_28">making use of local produce, combi-</div>
<div class="jstfy" id="page006_29">and dessert typical of Western meals,</div>
<div class="jstfy" id="page006_30">nations of ingredients and preparato-</div>
<div class="jstfy" id="page006_31">and of set meals consisting of multiple</div>
<div class="jstfy" id="page006_32">ry methods. Among the best-known</div>
<div class="jstfy" id="page006_33">courses.</div>
<div class="jstfy" id="page006_34">styles of regional cooking are those of</div>
<div class="jstfy" id="page006_35">Normandy, Brittany and Provence. In</div>
<div class="jstfy" id="page006_36">Food has always been an important</div>
<div class="jstfy" id="page006_37">simple terms, the food in the south of</div>
<div class="jstfy" id="page006_38">part in the daily life of the French,</div>
<div class="jstfy" id="page006_39">France is Mediterranean in style, while</div>
<div class="jstfy" id="page006_40">even today. At the time of the French</div>
<div class="jstfy" id="page006_41">that of the inland regions is heartier.</div>
<div class="jstfy" id="page006_42">Revolution, an increasing number of</div>
<div class="jstfy" id="page006_43">restaurants were opened, giving the</div>
<div class="jstfy" id="page006_44">French cuisine is often associated</div>
<div class="jstfy" id="page006_45">middle classes greater access to the</div>
<div class="jstfy" id="page006_46">with <span class="page006_46a">l’art de vivre</span>, the art of living.</div>
<div class="jstfy" id="page006_47">finest culinary arts. Cooks established</div>
<div class="jstfy" id="page006_48">This book intends to show how this art</div>
<div class="jstfy" id="page006_49">standards of preparation and quality</div>
<div class="jstfy" id="page006_50">can also be fully enjoyed in its vegan</div>
<div class="jstfy" id="page006_51">for the dishes they served in their res-</div>
<div class="jstfy" id="page006_52">version. With this in mind, we wish</div>
<div class="jstfy" id="page006_53">taurants. This newly developed ‘grande</div>
<div class="jstfy" id="page006_54">you <span class="page006_54a">bonne chance</span> and <span class="page006_54b">bon appétit</span>!</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// page_006.vue?3bb1a488